// hooks/usePagos.js - CORREGIDO (con actualización del pedido)

import { useState } from 'react';
import { getData } from '../../../../../services/library';
import { UrlApi } from '../../../../../services/apirest';

export const usePagos = (pedidoId) => {
  const [pagosPendientes, setPagosPendientes] = useState([]);
  const [loading, setLoading] = useState(false);

  const obtenerPagosPendientes = () => {
    getData("/envasado_pagos_combinados/xpedido/" + pedidoId, setPagosPendientes);
  };

  // Actualizar un pago individual (PUT inmediato)
  const actualizarPago = async (id, nuevoImporte) => {
    setLoading(true);
    try {
      const pagoOriginal = pagosPendientes.find(p => p.id === id);
      
      const datosActualizados = {
        // ...pagoOriginal,
        importe: nuevoImporte
      };

      const response = await fetch(`${UrlApi}/envasado_pagos_combinados/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosActualizados)
      });

      if (!response.ok) {
        throw new Error("Error al actualizar el pago");
      }

      // Actualizar estado local
      setPagosPendientes(prev => 
        prev.map(pago => 
          pago.id === id ? { ...pago, importe: nuevoImporte } : pago
        )
      );

      return true;
    } catch (error) {
      console.error("Error actualizando pago:", error);
      alert("Error al actualizar el pago");
      return false;
    } finally {
      setLoading(false);
    }
  };

  // NUEVA FUNCIÓN: Actualizar el estado del pedido a 308 (Pendiente de facturar)
  const actualizarEstadoPedido = async (pedido) => {
    try {
      const response = await fetch(`${UrlApi}/envasado_pedidos/${pedido.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ estado: 308 })
      });

      if (!response.ok) {
        throw new Error("Error al actualizar el estado del pedido");
      }

      return true;
    } catch (error) {
      console.error("Error actualizando pedido:", error);
      alert("Error al actualizar el estado del pedido");
      return false;
    }
  };

  // Agregar nuevo pago
  const agregarNuevoPago = async (datosPago) => {
    setLoading(true);
    try {
      const response = await fetch(`${UrlApi}/envasado_pagos_combinados`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(datosPago)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Error al crear el pago");
      }

      const nuevoPago = await response.json();
      setPagosPendientes(prev => [...prev, nuevoPago]);
      return nuevoPago;
    } catch (error) {
      console.error("Error creando pago:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Guardar el pedido completo (cuando los montos coinciden)
  const guardarPedido = async (pedido) => {
    setLoading(true);
    try {
      // Actualizar estado del pedido
      await actualizarEstadoPedido(pedido);
      
      return true;
    } catch (error) {
      console.error('Error al guardar el pedido:', error);
      alert('Error al guardar el pedido. Por favor, intente nuevamente.');
      return false;
    } finally {
      setLoading(false);
    }
  };

  const totalPagos = pagosPendientes.reduce(
    (sum, pago) => sum + (Number(pago.importe) || 0), 0
  );

  return {
    pagosPendientes,
    loading,
    totalPagos,
    obtenerPagosPendientes,
    actualizarPago,
    agregarNuevoPago,
    guardarPedido
  };
};